<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class InsuranceStoreMixin extends Vue {
        get productStore() {
            return insuranceStore
        }

        get productRuntimeStore() {
            return insuranceRuntimeStore
        }

        get productType() {
            return 'insurance'
        }
    }

    export default InsuranceStoreMixin
</script>
